module.exports = __webpack_public_path__ + "img/st-logo.00e23b6c.jpg";